export enum JourneySegmentTypes {
    Stop = "Stop",
    StopPhase = "StopPhase",
    Driving = "Driving",
    Movement = "Movement",
    None = "None"
}
